export enum EWinPresentationStates {
    WIN_PRESENTATION_HIDDEN_STATE = 'WIN_PRESENTATION_HIDDEN_STATE',
    PRE_WIN_PRESENTATION_STATE = 'PRE_WIN_PRESENTATION_STATE',
    WIN_PRESENTATION_IN_STATE = 'WIN_PRESENTATION_IN_STATE',
    WIN_PRESENTATION_IDLE_STATE = 'WIN_PRESENTATION_IDLE_STATE',
    WIN_PRESENTATION_HOLD_STATE = 'WIN_PRESENTATION_HOLD_STATE',
    WIN_PRESENTATION_OUT_STATE = 'WIN_PRESENTATION_OUT_STATE',
    POST_WIN_PRESENTATION_STATE = 'POST_WIN_PRESENTATION_STATE'
}

export enum EDebugWinPresentationEvents {
    DEBUG_WINPRESENTATION_START = 'DEBUG_WINPRESENTATION_START',
    DEBUG_WINPRESENTATION_START_PROCESSED = 'DEBUG_WINPRESENTATION_START_PROCESSED',
    DEBUG_WINPRESENTATION_CHANGE = 'DEBUG_WINPRESENTATION_CHANGE',
    DEBUG_WINPRESENTATION_5OFAKIND_CHANGE = 'DEBUG_WINPRESENTATION_5OFAKIND_CHANGE'
}
